module.exports = __webpack_public_path__ + "static/img/title.d8af8d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/feature/title.png
// module id = 732p
// module chunks = 7